export const handleScrollToTop = () => {
	window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
}